import React, { forwardRef } from 'react';
import Type from 'prop-types';
import cn from 'classnames';
import styles from './ListItemSecondaryAction.module.css';

const ListItemSecondaryAction = forwardRef(function ListItemSecondaryAction(props, ref) {
  const { className, ...other } = props;

  return <div className={cn(styles.root, className)} ref={ref} {...other} />;
});

/* eslint-disable */
ListItemSecondaryAction.propTypes = {
  children: Type.node,
  className: Type.string,
};
/* eslint-enable */

ListItemSecondaryAction.muiName = 'ListItemSecondaryAction';

export default ListItemSecondaryAction;
